import { Mesh } from "three";
import { FaceBufferGeometry } from "./facebuffergeometry";
const faceBufferGeometryCache = {
    ['face']: undefined,
    ['head']: undefined
};
const faceMeshCache = {
    ['face']: undefined,
    ['head']: undefined
};
const hasUpdatedDesignTimeCache = {
    ['face']: false,
    ['head']: false
};
const createMeshPromise = async ({ faceBufferGeometry, material, type }) => {
    // throw load promise which internally sets faceMesh at suspense
    if (!faceBufferGeometry.faceMesh) {
        await faceBufferGeometry._load(type === 'head');
    }
    if (!hasUpdatedDesignTimeCache[type]) {
        faceBufferGeometry.updateDesignTime();
    }
    // cache mesh
    faceMeshCache[type] = new Mesh(faceBufferGeometry, material);
};
const useFaceMeshLoader = ({ faceMeshLoaderOptions, material, type }) => {
    // if faceMesh already exists (after suspension) return mesh
    if (faceMeshCache[type])
        return faceMeshCache[type];
    // don't re-create face buffer geometry if already created
    if (!faceBufferGeometryCache[type])
        faceBufferGeometryCache[type] = new FaceBufferGeometry(faceMeshLoaderOptions);
    throw createMeshPromise({ material, faceBufferGeometry: faceBufferGeometryCache[type], type });
};
export default useFaceMeshLoader;
